import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import OverzichtScreen from '../components/OverzichtScreen';

const Overzicht: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Logboeken</IonTitle>
          <img slot="end" className="c-header-logo" src="assets/images/recvis.png" alt="logo recvis" />
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <OverzichtScreen />
      </IonContent>
    </IonPage>
  );
};

export default Overzicht;
